<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20"/>
    <path class="call_fill_hoverEffect" d="M16 17C13.7909 17 12 18.7909 12 21V29C12 31.2091 13.7909 33 16 33H26C28.2091 33 30 31.2091 30 29V27.8462L36.74 29.6608C37.3754 29.8318 38 29.3532 38 28.6952V21.3048C38 20.6468 37.3754 20.1682 36.74 20.3392L30 22.1538V21C30 18.7909 28.2091 17 26 17H16Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallVideo"
}
</script>

<style scoped>
rect{
    fill: var(--backgroundColor);
}
</style>
